import { render, staticRenderFns } from "./FaqPanels.vue?vue&type=template&id=4b065167&"
import script from "./FaqPanels.vue?vue&type=script&lang=js&"
export * from "./FaqPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports